/* jshint esversion: 8 */

const isInt = function (data) {
  const text = data.text;
  // const r = /^\+?[1-9][0-9]*$/; // 正整数
  const regx = /^\+?[0-9]*$/; // 正整数开始可以为0
  if (!regx.test(text)) return { code: 'error', msg: '非整数数字' };
  return { code: 'success', msg: '' };
};

const isFloat = function (data) {
  const text = data.text;
  if (!(!isNaN(parseFloat(text)) && !isNaN(text - 0))) return { code: 'error', msg: '非数字' };
  const regx = /^-?[\d.]+(?:e-?\d+)?$/;
  if (!(regx.test(text))) return { code: 'error', msg: '非数字' };
  return { code: 'success', msg: '' };
};

const isNumber = function (data) {
  const rst1 = isInt(data);
  const rst2 = isFloat(data);
  if (rst1.code === 'error' && rst2.code === 'error') {
    return { code: 'error', msg: '非数字' };
  } else {
    return { code: 'success', msg: '' };
  }
};
const isPhone = function (data) {
  const text = data.text;
  const regxNum = /^1[3-9]\d*$/;
  if (!regxNum.test(text)) return { code: 'error', msg: '非手机号码' };
  const regxPhone = /^1[3-9]\d{9}$/;
  if (!regxPhone.test(text)) return { code: 'error', msg: '手机号码长度不足11位' };
  return { code: 'success', msg: '' };
};
const isIdnum = function (data) {
  const text = data.text;
  const regx = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (!regx.test(text)) return { code: 'error', msg: '身份证号码格式不正确' };
  return { code: 'success', msg: '' };
};

const getPwdLevel = function (data) {
  const text = data.text;
  const regx = /^[-0-9a-zA-Z_!@#$%^&*]+$/;
  if (!regx.test(text)) return { code: 'error', msg: '密码格式错误' };
  if (text.length < 8) return { code: 'error', msg: '密码至少8位' };
  if (text.length > 100) return { code: 'error', msg: '密码太长' };
  const pwdStrengthLevel =
    (text.match(/[a-z]/) ? 1 : 0)
    + (text.match(/[A-Z]/) ? 1 : 0)
    + (text.match(/[0-9]/) ? 1 : 0)
    + (text.match(/[-_!@#$%^&*]/) ? 1 : 0);
  return { code: 'success', msg: '', pwdStrengthLevel };
};

const isWeakPwd = function (data) {
  const rst = getPwdLevel(data);
  if (rst.code === 'error') return { code: rst.code, msg: rst.msg };
  const pwdStrengthLevel = rst.pwdStrengthLevel;
  if (pwdStrengthLevel < 2) return { code: 'error', msg: '密码太弱，需要英文大小写、数字、特殊字符中至少2种' };
  return { code: 'success', msg: '' };
};
const isStrongPwd = function (data) {
  const rst = getPwdLevel(data);
  if (rst.code === 'error') return { code: rst.code, msg: rst.msg };
  const pwdStrengthLevel = rst.pwdStrengthLevel;
  if (pwdStrengthLevel < 3) return { code: 'error', msg: '密码太弱，需要英文大写、英文小写、数字、特殊字符中至少3种' };
  return { code: 'success', msg: '' };
};

/***
 * check:
 * onChange
 * type
 * minLength
 * maxLength
 * notNull
 * 
 * return 
 * code: success/error
 * msg:
 * hasErrorValue:
 * hasErrorIndex:
 * expectType:number/int/float/phone/idnum/weakPwd/strongPwd
 */
const checkParams = function (paramList) {
  let rst = { code: 'success', msg: '', hasErrorValue: '', hasErrorIndex: -1, expectType: '' };
  for (let i = 0; i < paramList.length; i++) {
    const iparam = paramList[i];
    const key = iparam.key;
    const ivalue = iparam.value;
    const iNotNull = iparam.notNull || '';
    const minLength = iparam.minLength || 0;
    const maxLength = iparam.maxLength || 99999;

    if (iNotNull && !ivalue) {
      rst.code = 'error';
      rst.msg = `${key}不能为空`;
      rst.hasErrorValue = ivalue;
      rst.hasErrorIndex = i;
      rst.expectType = iparam.type;
      break;
    }


    if (ivalue.length < minLength) {
      rst.code = 'error';
      rst.msg = `${key}内容太短，最短为${minLength}位`;
      rst.hasErrorValue = ivalue;
      rst.hasErrorIndex = i;
      rst.expectType = iparam.type;
      break;
    }


    if (ivalue.length > maxLength) {
      console.log(`----- 6`);
      rst.code = 'error';
      rst.msg = `${key}内容太长，最长为${maxLength}位`;
      rst.hasErrorValue = ivalue;
      rst.hasErrorIndex = i;
      rst.expectType = iparam.type;
      break;
    }

    const itype = iparam.type || '';
    if (itype && ivalue !== '') {
      console.log(`----- 2`);
      let irst = { code: 'success', msg: '' };
      switch (itype) {
        case 'number':
          irst = isNumber({ text: ivalue });
          break;
        case 'int':
          irst = isInt({ text: ivalue });
          break;
        case 'float':
          irst = isFloat({ text: ivalue });
          break;
        case 'phone':
          irst = isPhone({ text: ivalue });
          break;
        case 'idnum':
          irst = isIdnum({ text: ivalue });
          break;
        case 'weakPwd':
          irst = isWeakPwd({ text: ivalue });
          break;
        case 'strongPwd':
          irst = isStrongPwd({ text: ivalue });
          break;
        default:
          break;
      }
      if (irst.code === 'error') {
        rst.code = 'error';
        rst.msg = `${key} ` + irst.msg;
        rst.hasErrorValue = ivalue;
        rst.hasErrorIndex = i;
        rst.expectType = itype;
        break;
      }
    }
  }
  console.log(`----- 4`);
  return rst;
};
exports.checkParams = checkParams;
exports.isNumber = isNumber;
exports.isInt = isInt;
exports.isFloat = isFloat;
exports.isPhone = isPhone;
exports.isIdnum = isIdnum;
exports.isWeakPwd = isWeakPwd;
exports.isStrongPwd = isStrongPwd;
exports.getPwdLevel = getPwdLevel;
